<template>
    <div>
        <!-- <subNavbar :list="list" @click="subNavbarItemClick"/> -->
        <!-- <div>
            <img src="../assets/banner/联系我们banner1920x280px.png">
        </div>
        <div class="container margin-auto margin-top-30">
            <orderMenu :list="nav.lianxiwomen" ref="orderMenu"/>
        </div> -->
        <img src="../assets/link/网站-01.jpg" alt="">
        <!-- <img src="../assets/link/网站-02.jpg" alt=""> -->
        <img src="../assets/link/网站-14.jpg" alt="">
        <img src="../assets/link/网站-15.jpg" alt="">
        <img src="../assets/link/网站-03.jpg" alt="" @click="$router.push('/choeseTanjian')">
        <img src="../assets/link/网站-04.jpg" alt="" @click="$router.push('/joinTanjian')">
        <img src="../assets/link/网站-05.jpg" alt="" @click="$router.push('/workInTanjian')">
        <img src="../assets/link/网站-06.jpg" alt="">
        <img src="../assets/link/网站-07.jpg" alt="">
    </div>
</template>

<script>
import subNavbar from '../components/subNavbar'
import orderMenu from '../components/orderMenu'
import { mapGetters, mapMutations } from 'vuex'
export default {
    name: 'Link',
    components: {
        subNavbar,
        orderMenu
    },
    computed: {
        ...mapGetters({
            nav: 'getNav'
        })
    },
    data() {
        return {
            list: [
                { title: '联系我们', html: '联系我们' },
            ]
        }
    },
    created() {
    },
    methods: {
        subNavbarItemClick(index) {
            this.$refs.orderMenu.setActive(index)
        }
    }
}
</script>

<style lang="scss" scoped>
img {
    width: 100%;
}
</style>